import { FC } from 'react';
import { Link } from 'atoms/Link/Link';
import { ResultTitle } from 'pages/Search/ResultTitle';
import { CategoryItem } from 'pages/Search/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const SuggestedCategories: FC<{
  categoryList?: CategoryItem[];
}> = ({ categoryList }) => {
  const t = useTranslations();

  return (
    <div className={styles.categoriesWrapper}>
      <ResultTitle title={t('search.titles.suggested-categories')} />
      <div className={styles.categories}>
        {categoryList?.map((item) => (
          <Link className={styles.category} key={item.url} href={item.url}>
            {item.name}
          </Link>
        ))}
      </div>
    </div>
  );
};
